import { Base_Url } from "../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../Api Method/ApiMethod";

const MasterStateBaseUrl = `${Base_Url}/enquiry`;


export const enquiryList = async (params) => {
  let url = `${MasterStateBaseUrl}/enquiryList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
 
export const changeEnquiryStatus = async (id) => {
  let url = `${MasterStateBaseUrl}/changeEnquiryStatus?enquiryKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};
export const deleteEnquiry = async (id) => {
  let url = `${MasterStateBaseUrl}/deleteEnquiry?enquiryKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};

export const addUpdateEnquiry = async (url = '', params) => {
    // if (params.stateID === null || params.stateID === undefined) {
    //   delete params.stateID;
    // }
  
    const res = await postApiWithAuthenticated(`${MasterStateBaseUrl}${url}`, params);
    return res;
  };
// export const AddUpdateStateApi = async (url = '', params) => {
//   if (params.stateID === null || params.stateID === undefined) {
//     delete params.stateID;
//   }

//   const res = await postApiWithAuthenticated(`${MasterStateBaseUrl}${url}`, params);
//   return res;
// };


// export const GetStateModel = async (id) => {
//     let url = `${MasterStateBaseUrl}/GetStateModel?StateID=${id}`;
  
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };


// export const GetStateLookupList = async () => {
//     const url = `${MasterStateBaseUrl}/GetStateLookupList`;
  
//     const res = await getListWithAuthenticated(url );
//     return res;
//   };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${MasterStateBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };